import { CustomerImportStatusHelper } from "../../helper/customer-import-status.helper";

export class CustomerImportFilter {
    start: string;
    end: string;
}
